import Button from '../Button/ButtonComponent';
import ModalComponent from '../Modal';
import Text from '../Text/TextComponent';
import Flex from '../Flex/FlexComponent';
import LayoutChangesTmpStorageService from 'context/REDL/layoutChangesTmpStorageService';
import moment from 'moment';

export default function LayoutChangesTmpStorageModal({ show = true, usuari, pathname, layout, onClose, onConfirm }) {
    
    const layoutsData = LayoutChangesTmpStorageService.get(usuari, pathname, layout);
    const handleOnClose = () => {
        LayoutChangesTmpStorageService.clear(usuari, pathname, layout);
        onClose?.();
    };
    const handleOnConfirm = () => {
        const exists = LayoutChangesTmpStorageService.exists(usuari, pathname, layout);
        if (!exists) return;

        onConfirm?.({
            path: pathname,
            allData: layoutsData?.data.allData,
            structure: layoutsData?.data.structure,
        });
        onClose?.();
    };
    const getLastModificationString = () => moment(layoutsData?.creationDate).format('DD/MM/YYYY HH:mm:ss')

    return (
        <ModalComponent show={show} >
            <Flex maxWidth='100%' width='32rem' padding='2rem' container='flex' flexDirection='column' rowGap='1.5rem'>
                <div data-testid={`REDL-modal-temporal-storage`}>
                    <Text tag='h1' size='lg' weight='400'>
                        S&apos;ha detectat que estaves editant la pàgina i no vas arribar a desar les canvis. La darrera modificació és del {getLastModificationString()}.
                    </Text>
                    <Text tag='p' size='sm' weight='300' margin='lg'>
                        Vols continuar on ho vas deixar?
                    </Text>
                </div>
                <Flex container='flex' alignItems='center' justifyContent='center' rowGap='1rem' columnGap='1rem'>
                    <Button variant='tertiary' size='sm-lg' onClick={handleOnClose} data-testid={`REDL-modal-cancel-button`}>
                        Descarta els canvis
                    </Button>
                    <Button variant='primary' size='sm-lg' onClick={handleOnConfirm} data-testid={`REDL-modal-recovery-button`}>
                        Continua editant
                    </Button>
                </Flex>
            </Flex>
        </ModalComponent>
    );
}
